import React from 'react';

const OrganizationFeedModal = ({ 
  isOpen, 
  onClose, 
  selectedOrg, 
  orgFeeds 
}) => {
  const formatShortDate = (dateString) => {
    if (!dateString) return 'Not specified';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return 'Invalid Date';
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  };

  if (!isOpen || !selectedOrg) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        <div className="sticky top-0 bg-white border-b border-gray-200 p-6 rounded-t-xl">
          <div className="flex items-center justify-between">
            <div>
              <h3 className="text-xl font-bold text-gray-900">
                {selectedOrg.fullName || `${selectedOrg.firstName} ${selectedOrg.lastName}`}
              </h3>
              <p className="text-gray-600">Organization Feed</p>
            </div>
            <button
              onClick={onClose}
              className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>
        
        <div className="p-6">
          {orgFeeds[selectedOrg._id]?.length > 0 ? (
            <div className="space-y-4">
              {orgFeeds[selectedOrg._id].map((post, index) => (
                <div key={index} className="border border-gray-200 rounded-lg p-4">
                  <div className="flex items-center space-x-3 mb-3">
                    <div className="w-10 h-10 bg-blue-200 rounded-full flex items-center justify-center">
                      <span className="text-sm font-bold text-blue-700">
                        {selectedOrg.firstName?.charAt(0) || 'O'}
                      </span>
                    </div>
                    <div>
                      <p className="font-medium text-gray-900">
                        {selectedOrg.fullName || `${selectedOrg.firstName} ${selectedOrg.lastName}`}
                      </p>
                      <p className="text-xs text-gray-500">
                        {post.createdAt ? formatShortDate(post.createdAt) : 'Recent'}
                      </p>
                    </div>
                  </div>
                  <p className="text-gray-700 mb-3">{post.content || post.description}</p>
                  {post.image && (
                    <img src={post.image} alt="Post" className="w-full h-48 object-cover rounded-lg" />
                  )}
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center py-8">
              <p className="text-gray-500">No posts available from this organization.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default OrganizationFeedModal; 